var React = require('react');

function ArrowBr (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 1.375L8.75 8.625L16 1.375","stroke":"black","strokeWidth":"1.5","strokeLinejoin":"round"}));
}

ArrowBr.defaultProps = {"width":"17","height":"10","viewBox":"0 0 17 10","fill":"none"};

module.exports = ArrowBr;

ArrowBr.default = ArrowBr;
